import BasePopup from '../Base/BasePopup';

export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/es/Popup/MultiplePopup.js
// module id = 2638
// module chunks = 0